/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whats_New_SubtitleInputs */

const vi_whats_new_subtitle = /** @type {(inputs: Whats_New_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Những cập nhật & cải tiến mới nhất của hệ thống`)
};

/**

* @param {Whats_New_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const whats_new_subtitle = /** @type {((inputs?: Whats_New_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_New_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_whats_new_subtitle(inputs)
});